module.exports = __webpack_public_path__ + "static/media/initial_concept_for_poster_art_of_my_retrospective_show_2017.7d534dad.webp";